const elements2 = document.querySelectorAll('.js-metaobject-notice-cart');

if (!elements2.length > 0) return;
let currentIndex2 = 0;
function switchElements2() {
  if (elements2[currentIndex2]) elements2[currentIndex2].classList.remove('active');
  currentIndex2 = (currentIndex2 + 1) % elements2.length;
  if (elements2[currentIndex2]) elements2[currentIndex2].classList.add('active');
}
setInterval(switchElements2, 2800);
